const discountErrorsPrioritised = [
    'PROMO_NOT_AVAILABLE',
    'PROMO_MAX_REDEMPTIONS_REACHED',
    'COUPON_MAX_REDEMPTIONS_REACHED',
    'PROMO_MINIMUM_AMOUNT_NOT_MET',
    'COUPON_PRODUCT_RESTRICTION',
    'PROMO_CUSTOMER_RESTRICTION',
    'PROMO_MINIMUM_AMOUNT_CURRENCY_MISMATCH',
    'PROMO_EXPIRED',
    'PROMO_NOT_ACTIVE',
    'COUPON_NOT_FOUND',
    'COUPON_NOT_ACTIVE',
    'COUPON_EXPIRED',
    'COUPON_NOT_VALID',
]

function getHighestPriorityErrorCode(validationErrors) {
    for (const errorCode of discountErrorsPrioritised) {
        if (validationErrors.filter(e => e.code === errorCode).length > 0) {
            return errorCode
        }
    }
    return 'PROMO_NOT_AVAILABLE'
}

export default {
    getHighestPriorityErrorCode
}